/** Routes that do not require an authenticated session. */
const PUBLIC_PATHS = new Set([
  '/login',
  '/session-expired',
  '/complete-registration',
  '/unauthorized'
]);

/** Signed-out screens should never show the authenticated app nav. */
const APP_NAV_HIDDEN_PATHS = new Set([
  '/login',
  '/session-expired'
]);

export function isPublicAppPath(pathname) {
  return PUBLIC_PATHS.has(pathname);
}

export function shouldHideAppNav(pathname) {
  return APP_NAV_HIDDEN_PATHS.has(pathname);
}
